export default {
  methods: {
    decimalMaskToNumber(value) {
      return Number(String(value).replace('.', '').replace(',', '.'));
    },
  },
};
